/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import SharedStatusBadge from "@/components/SharedStatusBadge/SharedStatusBadge";
import { CreditBehaviourDataRow } from "@/Pages/Dashboard/LeftSide/types";
import { Typography } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import MuiTableRow from "@mui/material/TableRow";

import { colors } from "@dotnet/telematics-design-system";

interface CreditBehaviourTableRowProps {
  dataRow: CreditBehaviourDataRow;
  index: number;
}

const CreditBehaviourTableRow = ({
  dataRow,
  index
}: CreditBehaviourTableRowProps) => {
  const { creditBehaviour, device, vehicleStatus } = dataRow;

  const boxShadowBottom = `inset 0px -1px 0px ${colors.gray200}`;

  return (
    <MuiTableRow
      data-testid={`credit_behaviour_row_table_row_${index}`}
      id={`credit_behaviour_row_${index}`}
      css={css([
        {
          td: {
            boxShadow: index === 3 ? undefined : boxShadowBottom,
            background: colors.white,
            color: colors.textDark,

            padding: "10px 12px",

            overflowX: "hidden",
            textOverflow: "unset",

            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }
        }
      ])}
    >
      <TableCell>
        <SharedStatusBadge status={vehicleStatus} showTooltip={false} />
      </TableCell>

      <TableCell>
        <Typography variant="body3Medium">{device}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant="body3Medium">{creditBehaviour}</Typography>
      </TableCell>
    </MuiTableRow>
  );
};

export default CreditBehaviourTableRow;
